module.exports = __webpack_public_path__ + "img/kapila-siriwardhana-leccturing-01-small.5dcc1245.jpg";